/*
*###############################################################################
*Module Name                   : DPTextBoxButton.js                            #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : Dinisuru Balasuriya                           #
*Date                          : Friday, November 12th 2021, 17:07:32 pm       #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState } from 'react';
import { Row, Label, Input, Button } from "reactstrap"


const DPTextBoxButton = ({ rowClass, labelText, textType, value, onChange, placeholder, textAlign, disabled, onKeyPress, onBlur, id, onButtonClick, btnDisable, btnEnable }) => {
    return (
        <Row className={rowClass}>
            <Label
                htmlFor="example-text-input"
                className="col-md-3 col-form-label-sm"
            >
                {labelText}
            </Label>
            <div className="col-md-9" style={{ display: "flex", height: "30px" }}>
                <Input
                    className="form-control-sm"
                    type={textType}
                    value={value}
                    onChange={onChange}
                    onKeyPress={onKeyPress}
                    autoComplete='off'
                    onBlur={onBlur}
                    placeholder={placeholder}
                    style={{ textAlign: textAlign ? textAlign : 'left', }}
                    disabled={disabled}
                    id={id}
                />

                <Button
                    color="primary"
                    className="btn-sm"
                    onClick={onButtonClick}
                    disabled={btnDisable}
                    size="sm"
                >
                    <i
                        className="mdi mdi-new-box"
                        style={{ fontSize: "12px" }}
                    ></i>
                </Button>
            </div>


        </Row>
    );
}

export default DPTextBoxButton;